module.exports = __webpack_public_path__ + "img/resort-directly.78f10a90.png";